import { Stack } from '@mui/material';
import { RedoIcon, UndoIcon } from '~/assets/workspace-icons';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { useRegistrationUndoRedo } from '~/hooks/undo/useRegistrationUndoRedo';

interface RegistrationUndoRedoToolProps {
    isDisabled: boolean;
}

export default function RegistrationUndoRedoTool({
    isDisabled,
}: RegistrationUndoRedoToolProps) {
    const { canUndo, canRedo, undo, redo } = useRegistrationUndoRedo();

    return (
        <Stack direction="row" alignItems="center">
            <ToolbarButton
                icon={<UndoIcon />}
                tooltip={canUndo ? 'Undo registration' : 'Nothing to undo'}
                tooltipPlacement="bottom"
                disabled={!canUndo || isDisabled}
                onClick={undo}
                data-testid="registration-undo"
            />
            <ToolbarButton
                icon={<RedoIcon />}
                tooltip={canRedo ? 'Redo registration' : 'Nothing to redo'}
                tooltipPlacement="bottom"
                disabled={!canRedo || isDisabled}
                onClick={redo}
                data-testid="registration-redo"
            />
        </Stack>
    );
}
